import { ProviderType } from 'features/connections'
import { buildAnalysisQueryFromSource } from '../../utils'
import { BufferMeasure, BufferSettingsQuery, BufferSettingsQueryParams } from '../types'
import { generateQuery as generateQueryForBigQuery } from './bq'
import { generateQuery as generateQueryForSnowflake } from './sf'
import { generateQuery as generateQueryForRedshift } from './rs'
import { generateQuery as generateQueryForPostgres } from './pg'
import { ANALYSIS_FIELDS_DENYLIST } from 'features/builder/ui/builderConstants'

export function generateBufferQuery({
  mainSource,
  radius,
  measure,
  type,
  tracts,
  atLocation
}: BufferSettingsQuery): string {
  const radiusInMeters = measure === BufferMeasure.Meters ? radius : radius * 1000
  const geomField = mainSource.geoColumn || mainSource.metadata?.schema?.find((c) => c.type === 'geometry')?.name
  const baseQuery = buildAnalysisQueryFromSource({ source: mainSource })

  const payload: BufferSettingsQueryParams = {
    geomField,
    columns: mainSource.metadata?.schema?.filter((c) => c.type !== 'geometry' && !ANALYSIS_FIELDS_DENYLIST.has(c.name)),
    radiusInMeters,
    type,
    tracts,
    baseQuery: baseQuery,
    atLocation
  }

  const connectionProvider = mainSource.providerId
  switch (connectionProvider) {
    case ProviderType.BIGQUERY:
      return generateQueryForBigQuery(payload)
    case ProviderType.SNOWFLAKE:
      return generateQueryForSnowflake(payload)
    case ProviderType.REDSHIFT:
      return generateQueryForRedshift(payload)
    case ProviderType.POSTGRES:
      return generateQueryForPostgres(payload)
    default:
      throw new Error(`Analysis not implemented for ${connectionProvider}`)
  }
}
